import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';
import createNetworkingClient from 'utils/networking-client';

import sortAndFilter from './utils';

const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

let networkingClientInstance = null;
const networkingClient = () => {
  if (!networkingClientInstance) {
    networkingClientInstance = createNetworkingClient({
      adapter: cacheAdapterEnhancer(axios.defaults.adapter)
    });
  }
  return networkingClientInstance;
};

const entityMap = { activity: 'activities', post: 'posts' };

const getCachedAthletes = () =>
  JSON.parse(localStorage.getItem('strava.cachedAthletes'));

const setCachedAthletes = (data) => {
  localStorage.setItem('strava.cachedAthletes', JSON.stringify(data));
};

const initCache = () => {
  const cachedAthletes = getCachedAthletes();

  if (
    cachedAthletes === null ||
    cachedAthletes.timestamp + CACHE_TTL < new Date().getTime()
  ) {
    setCachedAthletes({
      timestamp: new Date().getTime()
    });
  }
};

const updateCache = (data, url, viewingAthleteId) => {
  const mentionableAthletes = sortAndFilter(data, viewingAthleteId);
  const cachedAthletes = getCachedAthletes();
  cachedAthletes[url] = mentionableAthletes;
  setCachedAthletes(cachedAthletes);

  return mentionableAthletes;
};

const fetchData = (url, viewingAthleteId) => {
  const cachedAthletes = getCachedAthletes();
  if (typeof cachedAthletes[url] !== 'undefined') {
    return new Promise((resolve) => resolve(cachedAthletes[url]));
  }
  return networkingClient()
    .get(url)
    .then(({ data }) => updateCache(data, url, viewingAthleteId));
};

const fetchAthletes = ({ entity, entityId, viewingAthleteId }) => {
  initCache();
  let data;
  if (entity && entityId) {
    data = fetchData(
      `/${entityMap[entity.toLowerCase()]}/${entityId}/mentionable_athletes`,
      viewingAthleteId
    );
  } else {
    data = fetchData('/athlete/mentionable_athletes', viewingAthleteId);
  }
  return data;
};

export default fetchAthletes;
